import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Campaigns } from 'src/app/interfaces/CampaignsData';
import { MisCampaniasService } from 'src/app/service/misCampanias.service';

@Component({
  selector: 'app-mis-campanias-detalles',
  templateUrl: './mis-campanias-detalles.component.html',
  styleUrls: ['./mis-campanias-detalles.component.scss']
})
export class MisCampaniasDetallesComponent implements OnInit{
  deviceUrl: string = '';
  deviceName: string = '';
  id!: number;
  campaign: Campaigns[] = [];
  campaignDetails: Campaigns = {
    id: 0,
    token: '',
    nombreCampania: '',
    tipoCampania: '',
    estatusCampania: '',
    usuario: '',
    verificarNumeros: '',
    detallesEstatus: '',
    fechaHoraInicio: 0,
    fechaHoraFin: 0
  }

  totalExitos: number = 0;
  totalProcesados: number = 0;
  totalErrores: number = 0;
  successfulMessages: any[] = [];
  incorrectMessages: any[] = [];
  noFindNumbers: any[] = [];

  chartData: any;
  chartOptions: any;

  showTableContent: boolean = false;

  constructor(private campaniasService: MisCampaniasService, private route: ActivatedRoute, private router: Router, private translate: TranslateService){
    const idString = this.route.snapshot.paramMap.get('id');
    if (idString) {
      this.id = parseInt(idString);
    } else {
      console.error('El ID del registro no está disponible.');
    }
    // Establecer idiomas disponibles y el idioma por defecto
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('es');
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');

      if(this.id){
        //llama al servicio para obtener los detalles de la campaña por id
        this.campaniasService.getCampaignById(this.id)
        .subscribe((campaign:Campaigns) => {
          this.campaignDetails = campaign;
          try {
            const parsedStatus = JSON.parse(campaign.detallesEstatus);
            this.totalExitos = parsedStatus.totalExitos;
            this.totalProcesados = parsedStatus.totalProcesados;
            this.totalErrores = parsedStatus.totalErrores;

            // Extract successful messages from the 'numeros' array
            if (parsedStatus.numeros) {
              this.successfulMessages = parsedStatus.numeros.filter(
                (message: any) => message.estatus === 'Correcto'
              );
              this.incorrectMessages = parsedStatus.numeros.filter(
                (message: any) => message.estatus === 'Error al enviar'
              );
              this.noFindNumbers = parsedStatus.numeros.filter(
                (message: any) => message.estatus === 'WhatsApp no existe'
              );

              this.initializeChart();  
            }

          } catch (error: unknown) {
            if (error instanceof String) { // Check for String error
              console.error('Error parsing detallesEstatus:', error.toString()); // Convert String error to string
            } else {
              console.error('Unexpected error:', error);
            }
          }
        }, error => console.log(error));
      }
    });

    this.route.queryParams.subscribe(params => {
      const token = params['deviceUrl'] || '';
      const nombre = params['deviceName'] || '';
      if (token) {
        this.deviceUrl = token;
      } 
      if(nombre){
        this.deviceName = nombre;
      }
    });
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });

  }

  getCampaignById(id: number): void {
    this.route.paramMap.subscribe(params => {
      const idString  = params.get('id');
      if (idString) {
        const id = parseInt(idString);
        // Llama al servicio para obtener los detalles de la lista por su ID
        this.campaniasService.getCampaignById(id)
        .subscribe((campaign:Campaigns) => {
          this.campaignDetails = campaign;
          });
      } else {
        alert("El ID del registro no es válido");
      }
    });
  }

  regresar(deviceUrl: string, deviceName: string){
    this.router.navigate(['/my-campaigns'], {queryParams: {deviceUrl: deviceUrl, deviceName: deviceName},
    queryParamsHandling: 'merge'});
  }

  initializeChart(): void {
    const documentStyle = getComputedStyle(document.documentElement);
    const valor1 = this.successfulMessages.length;
    const valor2 = this.noFindNumbers.length;
    const valor3 = this.incorrectMessages.length;

    this.chartData = {
      labels: [this.translate.instant('SUCCESFULL_DETAILS'), this.translate.instant('NOT_FOUND_DETAILS'), this.translate.instant('FAILED_DETAILS')],
      datasets: [{
        data: [valor1, valor2, valor3],
        backgroundColor: ['green', 'orange', 'red'],  
        hoverBackgroundColor: [documentStyle.getPropertyValue('--green-400'), documentStyle.getPropertyValue('--orange-400'), documentStyle.getPropertyValue('--red-400')]
      }]
    };

    this.chartOptions = {
      legend: {
        display: true,
        position: 'bottom' 
      },
      title: {
        display: true,
        text: 'Estado de los envíos' 
      },
      responsive: true 
    };
  }

  toggleTable() {
    this.showTableContent = !this.showTableContent;
}
}